import http, {SuccessEvent} from "../../common/ts/core/http";

function retentionUrlApiClassicTs() {
    if (window.location.hostname.includes(".local.")) {
        return "http://retention.local.mitula.com";
    } else if (window.location.hostname.includes(".dev.")) {
        return "https://retention.dev.mitula.com";
    } else {
        return "https://retention.mitula.com";
    }
}

function createEmailAlert({search, email, wantNews = false , successEvent} : {search: string, email: string, wantNews?: boolean, successEvent?: SuccessEvent}) {
    return new http.PostEvent({
        url: retentionUrlApiClassicTs() + "/servletGestionAlertas?host=" + window.location.hostname,
        body: {
            'what': search,
            'email': email,
            'action': '2',
            'receiveDems': wantNews ? 'on' : 'off',
        },
        formUrlencoded: true,
        successEvent
    })
}

function createMultipleEmailAlerts({ searches, email, wantNews = false, successEvent } : { searches: string[], email: string, wantNews?: boolean, successEvent?: SuccessEvent }) {
    return new http.PostEvent({
        url: retentionUrlApiClassicTs() + "/servletGestionAlertas?host=" + window.location.hostname,
        body: {
            'whats': searches.toString(),
            'email': email,
            'action': '2',
            'receiveDems': wantNews ? 'on' : 'off',
        },
        formUrlencoded: true,
        successEvent
    })
}

export default {
    events: {
        createEmailAlert,
        createMultipleEmailAlerts,
    }
}